import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Button from '../../../components/button/Button';
import InputItem from '../../../components/input-item/InputItem';
import Toast from '../../../components/toast/Toast';
import RFIDInstance from '../../../native-interact/RFID';
import nativeInterface from '../../../native-interact/native';
import { globalStore } from '../../../mobx/stores/global';

class BtbOn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: '',
    };

    this.openBlb = this.openBlb.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.setState({
      time: e.target.value,
    });
  }

  openBlb() {
    const loading = Toast.loading('正在开启');
    RFIDInstance.startBluetoothBroadcast(this.state.time).then(() => {
      loading.destroy();
      nativeInterface.cancelReconnectBle();
      globalStore.retryConnectBle = false;
      Toast.success('开启成功');
    });
  }

  render() {
    return (
      <div>
        <h4 className="popup-title">开启地磁蓝牙广播</h4>
        <InputItem
          label="开启时长"
          placeholder="请输入时长（单位：秒）"
          value={this.state.time}
          onChange={this.onChange}
        />
        <div style={{ textAlign: 'center' }}>
          <Button type="primary" onClick={this.openBlb}>
            开启
          </Button>
        </div>
      </div>
    );
  }
}

export default observer(BtbOn);
